__turbopack_context__.v({
  "caret": "FoodSuggestions-module__J4UU2a__caret",
  "root": "FoodSuggestions-module__J4UU2a__root",
});
